import React from 'react';
 
const Footer = () => {
  return (
    <footer>
      <p>&copy; 2026 Caterina Esposito. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
